import PropTypes from 'prop-types';
import { ReactComponent as IconBlock } from "assets/images/icons/block.svg";
import Button from "components/ui/Button/Button";
import useData from "hooks/useData";
import { useEffect, useState } from "react";

const ButtonBlock = ({ userId }) => {
  const { getData, postData, deleteData } = useData();
  const [ isLoading, setIsLoading ] = useState();
  const [ isBlocked, setIsBlocked ] = useState();

  useEffect(
    () => {
      const load = async () => {
        setIsLoading(true);
        const { data } = await getData(`rest/user/${ userId }/block`);
        setIsBlocked(data?.id);
        setIsLoading(false);
      }
      load();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

  const block = () => {
    const doBlock = async () => {
      const result = await postData(`rest/user/${ userId }/block`);
      if (result.status === 201) {
        setIsBlocked(true);
      }
    }
    doBlock();
  }

  const unBlock = () => {
    const doUnBlock = async () => {
      const result = await deleteData(`rest/user/${ userId }/block`);
      if (result.status === 204) {
        setIsBlocked(false);
      }
    }
    doUnBlock();
  }

  if (isLoading) {
    return null;
  }

  return (
    <Button variant={ isBlocked ? `warning` : `ghost` } className="button--small" onClick={ () => isBlocked ? unBlock() : block() }>
      <IconBlock/>
      { isBlocked ? 'Blokkering verwijderen' : 'Gebruiker blokkeren' }
    </Button>
  )
}

ButtonBlock.propTypes = {
  userId: PropTypes.number.isRequired,
}

export default ButtonBlock;
